import { render, staticRenderFns } from "./SelectReviewProblem.vue?vue&type=template&id=983e5d5e&scoped=true&lang=pug&"
import script from "./SelectReviewProblem.vue?vue&type=script&lang=ts&"
export * from "./SelectReviewProblem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e5d5e",
  null
  
)

export default component.exports